/**
 * Shared Entra ID / MSAL configuration.
 *
 * Single source of truth for all Entra ID app-registration values used across
 * the web client, browser extension, mobile app, and auth service.
 */

export const ENTRA_CLIENT_ID = '6532bcfb-f955-4ee8-b4b0-343af07a9ec2';
/** @deprecated No longer used for SSO login — kept for connector client-credentials flows */
export const ENTRA_API_AUDIENCE = 'api://0ca4bb97-9038-424d-b7d7-219b678f5a78';
export const ENTRA_API_SCOPES = ['openid', 'profile', 'email'];
export const ENTRA_AUTHORITY = 'https://login.microsoftonline.com/organizations';
